import React, { useState, useEffect } from "react";
import {
    Card,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
} from "@mui/material";
import signInBanner1 from '../../assets/signin_banner.jpg';
import signInBanner2 from '../../assets/signin_banner1.jpeg';
import signInBanner3 from '../../assets/signin_banner-2.jpeg';
import { useNavigate } from "react-router-dom";
import '../../css/App.css';
import googleLogo from '../../assets/google_logo.png';
import fbLogo from '../../assets/fb_logo.png';

/* const countries = [
    { code: "+91", label: "India" },
    { code: "+1", label: "USA" },
    { code: "+44", label: "UK" },
    // Add more as needed
]; */

const SignIn = () => {

    const navigate = useNavigate();
    const [useMobileLogin, setUseMobileLogin] = useState(false);
    const sidebanner = [signInBanner1, signInBanner2, signInBanner3];
    const [bannercurrentIndex, setBannerCurrentIndex] = useState(0);


    useEffect(() => {
        const interval = setInterval(() => {
            setBannerCurrentIndex((prev) => (prev + 1) % sidebanner.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    /* const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [mobileNumber, setMobileNumber] = useState("");
    const [countryCode, setCountryCode] = useState("+91");

    const handleSubmit = () => {
        if (useMobileLogin) {
            console.log("Logging in with:", countryCode + mobileNumber);
        } else {
            console.log("Logging in with:", email, password);
        }
    }; */

    return (
        <Box className="primary-box">

            {/* Left side with image ads */}
            <Box
                className="secondary-box"
                sx={{
                    padding: 2,
                }}
            >
                <img
                    src={sidebanner[bannercurrentIndex]}
                    alt="Ad Banner"
                    style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "cover",
                        width: '100%'
                    }}
                />
            </Box>

            {/* Right side with login card */}
            <Box className="secondary-box">
                <Card className="auth-card"
                    sx={{
                        p: 3
                    }}
                >
                    {/* Logo */}
                    <Box className="auth-logo"
                        sx={{
                            mx: "auto",
                            mb: 2,
                        }}
                    >
                        <Typography
                            sx={{ fontSize: "40px", color: "#fff", fontWeight: "bold" }}
                        >
                            F5
                        </Typography>
                    </Box>

                    {/* Title */}
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: 600, mb: 2, textAlign: "center" }}
                    >
                        {useMobileLogin ? "Enter your mobile number" : "Sign in with Email"}
                    </Typography>

                    {useMobileLogin ? (
                        <>
                            {/* Country Code with Mobile Field */}
                            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                <TextField
                                    select
                                    /* value={countryCode}
                                    onChange={(e) => setCountryCode(e.target.value)} */
                                    sx={{ width: "35%" }}
                                    size="small"
                                >
                                    {/* {countries.map((option) => ( */}
                                    <MenuItem /* key={option.code} value={option.code} */>
                                        {/* {option.code} */}
                                    </MenuItem>
                                    {/* ))} */}
                                </TextField>

                                <TextField
                                    fullWidth
                                    type="tel"
                                    label="Mobile Number"
                                    /* value={mobileNumber}
                                    onChange={(e) => setMobileNumber(e.target.value)} */
                                    size="small"
                                />
                            </Box>
                        </>
                    ) : (
                        <>
                            {/* Email Field */}
                            <TextField
                                fullWidth
                                type="email"
                                label="Email"
                                /* value={email}
                                onChange={(e) => setEmail(e.target.value)} */
                                sx={{ mb: 2 }}
                                size="small"
                            />
                            <Typography sx={{
                                color: '#C32032', textAlign: 'right', '&:hover': {
                                    textDecoration: 'underline'
                                }, cursor: 'pointer'
                            }}>Forgot Password?</Typography>
                            {/* Password Field */}
                            <TextField
                                fullWidth
                                type="password"
                                label="Password"
                                /* value={password}
                                onChange={(e) => setPassword(e.target.value)} */
                                sx={{ mb: 2 }}
                                size="small"
                            />
                        </>
                    )}

                    {/* Submit Button */}
                    <Button
                        fullWidth
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            backgroundColor: "#C32032",
                            mb: 1,
                        }}
                    >
                        {useMobileLogin ? "Send OTP" : "Sign In"}
                    </Button>

                    {/* Toggle between mobile or email signin */}
                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: "center",
                            cursor: "pointer",
                            textDecoration: "underline",
                            color: "#C32032",
                        }}
                        onClick={() => setUseMobileLogin(!useMobileLogin)}
                    >
                        {useMobileLogin
                            ? "Sign in with Email and Password"
                            : "Sign in with Mobile Number"}
                    </Typography>

                    {/* social signup */}
                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: "center",
                            marginTop: '4%'
                        }}
                    >
                        or signin with
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '2%' }}>
                        <Box
                            component="img"
                            src={googleLogo}
                            alt="google-logo"
                            sx={{
                                width: '8%',
                                border: '1px solid #C32032',
                                borderRadius: '20px',
                                padding: '4px'
                            }}
                        />

                        <Box
                            component="img"
                            src={fbLogo}
                            alt="google-logo"
                            sx={{
                                width: '10%',
                                border: '1px solid #C32032',
                                borderRadius: '20px',
                                padding: '2px'
                            }}
                        />
                    </Box>

                    {/* Toggle between signin and signup */}
                    <Box sx={{ display: 'flex', gap: "4px", marginTop: '15%' }}>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: "center",
                                color: "#000",
                            }}
                        >
                            New user?
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: "center",
                                cursor: "pointer",
                                textDecoration: "underline",
                                color: "#C32032",
                            }}
                            onClick={() => navigate('/signup')}
                        >
                            Create an account
                        </Typography>
                    </Box>
                </Card>
            </Box>
        </Box>
    );
};

export default SignIn;